// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__2tCeK","content":"styles_content__9cFzE"};